export const cloneXNFTs = [
  
  {
    "id": "clonex-19761",
    "name": "CloneX #19761",
    "image": "https://clonex-assets.rtfkt.com/images/19761.png",
    "price": "1.85 ETH"
  },
  {
    "id": "clonex-19760",
    "name": "CloneX #19760",
    "image": "https://clonex-assets.rtfkt.com/images/19760.png", 
    "price": "0.95 ETH"
  },
  {
    "id": "clonex-19759",
    "name": "CloneX #19759",
    "image": "https://clonex-assets.rtfkt.com/images/19759.png",
    "price": "1.45 ETH"
  },
  {
    "id": "clonex-19758", 
    "name": "CloneX #19758",
    "image": "https://clonex-assets.rtfkt.com/images/19758.png",
    "price": "0.65 ETH"
  },
  {
    "id": "clonex-19757",
    "name": "CloneX #19757", 
    "image": "https://clonex-assets.rtfkt.com/images/19757.png",
    "price": "1.95 ETH"
  },
  {
    "id": "clonex-19756",
    "name": "CloneX #19756",
    "image": "https://clonex-assets.rtfkt.com/images/19756.png",
    "price": "1.15 ETH"
  },
  {
    "id": "clonex-19755",
    "name": "CloneX #19755",
    "image": "https://clonex-assets.rtfkt.com/images/19755.png",
    "price": "0.45 ETH"
  },
  {
    "id": "clonex-19754",
    "name": "CloneX #19754",
    "image": "https://clonex-assets.rtfkt.com/images/19754.png",
    "price": "1.65 ETH"
  },
  {
    "id": "clonex-19753",
    "name": "CloneX #19753",
    "image": "https://clonex-assets.rtfkt.com/images/19753.png",
    "price": "0.85 ETH"
  },
  {
    "id": "clonex-19752",
    "name": "CloneX #19752",
    "image": "https://clonex-assets.rtfkt.com/images/19752.png",
    "price": "1.35 ETH"
  },
  {
    "id": "clonex-19751",
    "name": "CloneX #19751",
    "image": "https://clonex-assets.rtfkt.com/images/19751.png",
    "price": "0.55 ETH"
  },
  {
    "id": "clonex-19750",
    "name": "CloneX #19750",
    "image": "https://clonex-assets.rtfkt.com/images/19750.png",
    "price": "1.75 ETH"
  },
  {
    "id": "clonex-19749",
    "name": "CloneX #19749",
    "image": "https://clonex-assets.rtfkt.com/images/19749.png",
    "price": "1.25 ETH"
  },
  {
    "id": "clonex-19748",
    "name": "CloneX #19748",
    "image": "https://clonex-assets.rtfkt.com/images/19748.png",
    "price": "0.35 ETH"
  },
  {
    "id": "clonex-19747",
    "name": "CloneX #19747",
    "image": "https://clonex-assets.rtfkt.com/images/19747.png",
    "price": "1.55 ETH"
  },
  {
    "id": "clonex-19746",
    "name": "CloneX #19746",
    "image": "https://clonex-assets.rtfkt.com/images/19746.png",
    "price": "0.75 ETH"
  },
  {
    "id": "clonex-19745",
    "name": "CloneX #19745",
    "image": "https://clonex-assets.rtfkt.com/images/19745.png",
    "price": "1.85 ETH"
  },
  {
    "id": "clonex-19744",
    "name": "CloneX #19744",
    "image": "https://clonex-assets.rtfkt.com/images/19744.png",
    "price": "1.15 ETH"
  },
  {
    "id": "clonex-19743",
    "name": "CloneX #19743",
    "image": "https://clonex-assets.rtfkt.com/images/19743.png",
    "price": "0.25 ETH"
  },
  {
    "id": "clonex-19742",
    "name": "CloneX #19742",
    "image": "https://clonex-assets.rtfkt.com/images/19742.png",
    "price": "1.45 ETH"
  },
  {
    "id": "clonex-19741",
    "name": "CloneX #19741",
    "image": "https://clonex-assets.rtfkt.com/images/19741.png",
    "price": "0.95 ETH"
  },
  {
    "id": "clonex-19740",
    "name": "CloneX #19740",
    "image": "https://clonex-assets.rtfkt.com/images/19740.png",
    "price": "1.65 ETH"
  },
  {
    "id": "clonex-19739",
    "name": "CloneX #19739",
    "image": "https://clonex-assets.rtfkt.com/images/19739.png",
    "price": "0.85 ETH"
  },
  {
    "id": "clonex-19738",
    "name": "CloneX #19738",
    "image": "https://clonex-assets.rtfkt.com/images/19738.png",
    "price": "1.95 ETH"
  },
  {
    "id": "clonex-19737",
    "name": "CloneX #19737",
    "image": "https://clonex-assets.rtfkt.com/images/19737.png",
    "price": "1.35 ETH"
  },
  {
    "id": "clonex-19736",
    "name": "CloneX #19736",
    "image": "https://clonex-assets.rtfkt.com/images/19736.png",
    "price": "0.45 ETH"
  },
  {
    "id": "clonex-19735",
    "name": "CloneX #19735",
    "image": "https://clonex-assets.rtfkt.com/images/19735.png",
    "price": "1.75 ETH"
  },
  {
    "id": "clonex-19734",
    "name": "CloneX #19734",
    "image": "https://clonex-assets.rtfkt.com/images/19734.png",
    "price": "1.05 ETH"
  },
  {
    "id": "clonex-19733",
    "name": "CloneX #19733",
    "image": "https://clonex-assets.rtfkt.com/images/19733.png",
    "price": "0.15 ETH"
  },
  {
    "id": "clonex-19732",
    "name": "CloneX #19732",
    "image": "https://clonex-assets.rtfkt.com/images/19732.png",
    "price": "1.55 ETH"
  },
  {
    "id": "clonex-19731",
    "name": "CloneX #19731",
    "image": "https://clonex-assets.rtfkt.com/images/19731.png",
    "price": "0.75 ETH"
  },
  {
    "id": "clonex-19730",
    "name": "CloneX #19730",
    "image": "https://clonex-assets.rtfkt.com/images/19730.png",
    "price": "1.85 ETH"
  },
  {
    "id": "clonex-19729",
    "name": "CloneX #19729",
    "image": "https://clonex-assets.rtfkt.com/images/19729.png",
    "price": "1.25 ETH"
  },
  {
    "id": "clonex-19728",
    "name": "CloneX #19728",
    "image": "https://clonex-assets.rtfkt.com/images/19728.png",
    "price": "0.35 ETH"
  },
  {
    "id": "clonex-19727",
    "name": "CloneX #19727",
    "image": "https://clonex-assets.rtfkt.com/images/19727.png",
    "price": "1.65 ETH"
  },
  {
    "id": "clonex-19726",
    "name": "CloneX #19726",
    "image": "https://clonex-assets.rtfkt.com/images/19726.png",
    "price": "0.95 ETH"
  },
  {
    "id": "clonex-19725",
    "name": "CloneX #19725",
    "image": "https://clonex-assets.rtfkt.com/images/19725.png",
    "price": "1.45 ETH"
  },
  {
    "id": "clonex-19724",
    "name": "CloneX #19724",
    "image": "https://clonex-assets.rtfkt.com/images/19724.png",
    "price": "0.55 ETH"
  },
  {
    "id": "clonex-19723",
    "name": "CloneX #19723",
    "image": "https://clonex-assets.rtfkt.com/images/19723.png",
    "price": "1.95 ETH"
  },
  {
    "id": "clonex-19722",
    "name": "CloneX #19722",
    "image": "https://clonex-assets.rtfkt.com/images/19722.png",
    "price": "1.15 ETH"
  },
  {
    "id": "clonex-19721",
    "name": "CloneX #19721",
    "image": "https://clonex-assets.rtfkt.com/images/19721.png",
    "price": "0.25 ETH"
  },
  {
    "id": "clonex-19720",
    "name": "CloneX #19720",
    "image": "https://clonex-assets.rtfkt.com/images/19720.png",
    "price": "1.75 ETH"
  },
  {
    "id": "clonex-19719",
    "name": "CloneX #19719",
    "image": "https://clonex-assets.rtfkt.com/images/19719.png",
    "price": "1.05 ETH"
  },
  {
    "id": "clonex-19718",
    "name": "CloneX #19718",
    "image": "https://clonex-assets.rtfkt.com/images/19718.png",
    "price": "0.45 ETH"
  },
  {
    "id": "clonex-19717",
    "name": "CloneX #19717",
    "image": "https://clonex-assets.rtfkt.com/images/19717.png",
    "price": "1.85 ETH"
  },
  {
    "id": "clonex-19716",
    "name": "CloneX #19716",
    "image": "https://clonex-assets.rtfkt.com/images/19716.png",
    "price": "1.35 ETH"
  },
  {
    "id": "clonex-19715",
    "name": "CloneX #19715",
    "image": "https://clonex-assets.rtfkt.com/images/19715.png",
    "price": "0.65 ETH"
  },
  {
    "id": "clonex-19714",
    "name": "CloneX #19714",
    "image": "https://clonex-assets.rtfkt.com/images/19714.png",
    "price": "1.55 ETH"
  },
  {
    "id": "clonex-19713",
    "name": "CloneX #19713",
    "image": "https://clonex-assets.rtfkt.com/images/19713.png",
    "price": "0.85 ETH"
  },
  {
    "id": "clonex-19712",
    "name": "CloneX #19712",
    "image": "https://clonex-assets.rtfkt.com/images/19712.png",
    "price": "1.95 ETH"
  },
  {
    "id": "clonex-19711",
    "name": "CloneX #19711",
    "image": "https://clonex-assets.rtfkt.com/images/19711.png",
    "price": "1.25 ETH"
  },
  {
    "id": "clonex-19710",
    "name": "CloneX #19710",
    "image": "https://clonex-assets.rtfkt.com/images/19710.png",
    "price": "0.35 ETH"
  },
  {
    "id": "clonex-19709",
    "name": "CloneX #19709",
    "image": "https://clonex-assets.rtfkt.com/images/19709.png",
    "price": "1.65 ETH"
  },
  {
    "id": "clonex-19708",
    "name": "CloneX #19708",
    "image": "https://clonex-assets.rtfkt.com/images/19708.png",
    "price": "0.95 ETH"
  },

  {
    "id": "clonex-19707",
    "name": "CloneX #19707",
    "image": "https://clonex-assets.rtfkt.com/images/19707.png",
    "price": "1.45 ETH"
  },
  {
    "id": "clonex-19706",
    "name": "CloneX #19706",
    "image": "https://clonex-assets.rtfkt.com/images/19706.png",
    "price": "0.65 ETH"
  },
  {
    "id": "clonex-19705",
    "name": "CloneX #19705",
    "image": "https://clonex-assets.rtfkt.com/images/19705.png",
    "price": "1.85 ETH"
  },
  {
    "id": "clonex-19704",
    "name": "CloneX #19704",
    "image": "https://clonex-assets.rtfkt.com/images/19704.png",
    "price": "1.15 ETH"
  },
  {
    "id": "clonex-19703",
    "name": "CloneX #19703",
    "image": "https://clonex-assets.rtfkt.com/images/19703.png",
    "price": "0.35 ETH"
  },
  {
    "id": "clonex-19702",
    "name": "CloneX #19702",
    "image": "https://clonex-assets.rtfkt.com/images/19702.png",
    "price": "1.55 ETH"
  },
  {
    "id": "clonex-19701",
    "name": "CloneX #19701",
    "image": "https://clonex-assets.rtfkt.com/images/19701.png",
    "price": "0.85 ETH"
  },
  {
    "id": "clonex-19700",
    "name": "CloneX #19700",
    "image": "https://clonex-assets.rtfkt.com/images/19700.png",
    "price": "1.95 ETH"
  },
  {
    "id": "clonex-19699",
    "name": "CloneX #19699",
    "image": "https://clonex-assets.rtfkt.com/images/19699.png",
    "price": "1.25 ETH"
  },
  {
    "id": "clonex-19698",
    "name": "CloneX #19698",
    "image": "https://clonex-assets.rtfkt.com/images/19698.png",
    "price": "0.45 ETH"
  },
  {
    "id": "clonex-19697",
    "name": "CloneX #19697",
    "image": "https://clonex-assets.rtfkt.com/images/19697.png",
    "price": "1.75 ETH"
  },
  {
    "id": "clonex-19696",
    "name": "CloneX #19696",
    "image": "https://clonex-assets.rtfkt.com/images/19696.png",
    "price": "0.95 ETH"
  },
  {
    "id": "clonex-19695",
    "name": "CloneX #19695",
    "image": "https://clonex-assets.rtfkt.com/images/19695.png",
    "price": "1.35 ETH"
  },
  {
    "id": "clonex-19694",
    "name": "CloneX #19694",
    "image": "https://clonex-assets.rtfkt.com/images/19694.png",
    "price": "0.55 ETH"
  },
  {
    "id": "clonex-19693",
    "name": "CloneX #19693",
    "image": "https://clonex-assets.rtfkt.com/images/19693.png",
    "price": "1.85 ETH"
  },
  {
    "id": "clonex-19692",
    "name": "CloneX #19692",
    "image": "https://clonex-assets.rtfkt.com/images/19692.png",
    "price": "1.15 ETH"
  },
  {
    "id": "clonex-19691",
    "name": "CloneX #19691",
    "image": "https://clonex-assets.rtfkt.com/images/19691.png",
    "price": "0.25 ETH"
  },
  {
    "id": "clonex-19690",
    "name": "CloneX #19690",
    "image": "https://clonex-assets.rtfkt.com/images/19690.png",
    "price": "1.65 ETH"
  },
  {
    "id": "clonex-19689",
    "name": "CloneX #19689",
    "image": "https://clonex-assets.rtfkt.com/images/19689.png",
    "price": "0.75 ETH"
  },
  {
    "id": "clonex-19688",
    "name": "CloneX #19688",
    "image": "https://clonex-assets.rtfkt.com/images/19688.png",
    "price": "1.95 ETH"
  },
  {
    "id": "clonex-19687",
    "name": "CloneX #19687",
    "image": "https://clonex-assets.rtfkt.com/images/19687.png",
    "price": "1.45 ETH"
  },
  {
    "id": "clonex-19686",
    "name": "CloneX #19686",
    "image": "https://clonex-assets.rtfkt.com/images/19686.png",
    "price": "0.65 ETH"
  },
  {
    "id": "clonex-19685",
    "name": "CloneX #19685",
    "image": "https://clonex-assets.rtfkt.com/images/19685.png",
    "price": "1.85 ETH"
  },
  {
    "id": "clonex-19684",
    "name": "CloneX #19684",
    "image": "https://clonex-assets.rtfkt.com/images/19684.png",
    "price": "1.05 ETH"
  },
  {
    "id": "clonex-19683",
    "name": "CloneX #19683",
    "image": "https://clonex-assets.rtfkt.com/images/19683.png",
    "price": "0.35 ETH"
  },
  {
    "id": "clonex-19682",
    "name": "CloneX #19682",
    "image": "https://clonex-assets.rtfkt.com/images/19682.png",
    "price": "1.55 ETH"
  },
  {
    "id": "clonex-19681",
    "name": "CloneX #19681",
    "image": "https://clonex-assets.rtfkt.com/images/19681.png",
    "price": "0.85 ETH"
  },
  {
    "id": "clonex-19680",
    "name": "CloneX #19680",
    "image": "https://clonex-assets.rtfkt.com/images/19680.png",
    "price": "1.95 ETH"
  },
  {
    "id": "clonex-19679",
    "name": "CloneX #19679",
    "image": "https://clonex-assets.rtfkt.com/images/19679.png",
    "price": "1.25 ETH"
  },
  {
    "id": "clonex-19678",
    "name": "CloneX #19678",
    "image": "https://clonex-assets.rtfkt.com/images/19678.png",
    "price": "0.45 ETH"
  },
  {
    "id": "clonex-19677",
    "name": "CloneX #19677",
    "image": "https://clonex-assets.rtfkt.com/images/19677.png",
    "price": "1.75 ETH"
  },
  {
    "id": "clonex-19676",
    "name": "CloneX #19676",
    "image": "https://clonex-assets.rtfkt.com/images/19676.png",
    "price": "0.95 ETH"
  },
  {
    "id": "clonex-19675",
    "name": "CloneX #19675",
    "image": "https://clonex-assets.rtfkt.com/images/19675.png",
    "price": "1.35 ETH"
  },
  {
    "id": "clonex-19674",
    "name": "CloneX #19674",
    "image": "https://clonex-assets.rtfkt.com/images/19674.png",
    "price": "0.55 ETH"
  },
  {
    "id": "clonex-19673",
    "name": "CloneX #19673",
    "image": "https://clonex-assets.rtfkt.com/images/19673.png",
    "price": "1.85 ETH"
  },
  {
    "id": "clonex-19672",
    "name": "CloneX #19672",
    "image": "https://clonex-assets.rtfkt.com/images/19672.png",
    "price": "1.15 ETH"
  },
  {
    "id": "clonex-19671",
    "name": "CloneX #19671",
    "image": "https://clonex-assets.rtfkt.com/images/19671.png",
    "price": "0.25 ETH"
  },
  {
    "id": "clonex-19670",
    "name": "CloneX #19670",
    "image": "https://clonex-assets.rtfkt.com/images/19670.png",
    "price": "1.65 ETH"
  },
  {
    "id": "clonex-19669",
    "name": "CloneX #19669",
    "image": "https://clonex-assets.rtfkt.com/images/19669.png",
    "price": "0.75 ETH"
  },
  {
    "id": "clonex-19668",
    "name": "CloneX #19668",
    "image": "https://clonex-assets.rtfkt.com/images/19668.png",
    "price": "1.95 ETH"
  },
  {
    "id": "clonex-19667",
    "name": "CloneX #19667",
    "image": "https://clonex-assets.rtfkt.com/images/19667.png",
    "price": "1.45 ETH"
  },
  {
    "id": "clonex-19666",
    "name": "CloneX #19666",
    "image": "https://clonex-assets.rtfkt.com/images/19666.png",
    "price": "0.65 ETH"
  },
  {
    "id": "clonex-19665",
    "name": "CloneX #19665",
    "image": "https://clonex-assets.rtfkt.com/images/19665.png",
    "price": "1.85 ETH"
  },
  {
    "id": "clonex-19664",
    "name": "CloneX #19664",
    "image": "https://clonex-assets.rtfkt.com/images/19664.png",
    "price": "1.05 ETH"
  },
  {
    "id": "clonex-19663",
    "name": "CloneX #19663",
    "image": "https://clonex-assets.rtfkt.com/images/19663.png",
    "price": "0.35 ETH"
  },
  {
    "id": "clonex-19662",
    "name": "CloneX #19662",
    "image": "https://clonex-assets.rtfkt.com/images/19662.png",
    "price": "1.55 ETH"
  }



];